import ApiService from "@/core/services/api.service";

// Action types
export const INSPECTION_RESOURCE = "inspection-tasks/inspection";
export const INSPECTION_LIST = "inspection-list";
export const INSPECTION_CREATE = "inspection-create";
export const INSPECTION_ASSIGN = "inspection-tasks/inspection/coordinate-work";
export const INSPECTION_DELETE = "inspection/delete";
export const INSPECTION_UPDATE = "inspection/update";
export const INSPECTION_PERSONAL = "inspection-tasks/inspection/get-individual-tasks";
export const INSPECTION_TEACHER_CATEGORY_LIST = "inspection-tasks/inspection/get-list-teacher";
export const INSPECTION_TEACHER_CATEGORY_DOWNLOAD = "inspection-tasks/inspection/export-example";
export const INSPECTION_TEACHER_CATEGORY_IMPORT = "inspection-tasks/inspection/import-data";
export const INSPECTION_TEACHER_PREVIEW_IMPORT = "inspection-tasks/inspection/preview-data-import";
export const INSPECTION_EXPORT_ALL = "inspection-tasks/inspection/export";
export const INSPECTION_DETAIL = "inspection-detail";
export const INSPECTION_SUPPLEMENT_CANDIDATE = "inspection-tasks/inspection/get-homework-similar";
export const INSPECTION_GET_HOMEWORK = "inspection-tasks/inspection/get-homework";
export const INSPECTION_GET_PERSON_IN_CHARGE = "inspection-tasks/inspection/get-person-in-charge";
export const INSPECTION_SAVE_EVALUATE = "inspection-tasks/inspection/post-evaluation";
export const CREATE_ERROR_INSPECTION = "inspection-tasks/inspection/create-warning-error";
export const INSPECTION_GET_MARK = "inspection-tasks/inspection/get-mark";
export const INSPECTION_POST_MARK = "inspection-tasks/inspection/post-mark";
export const DELETE_SIMILAR_TASK = "inspection-tasks/inspection/delete-similar";
const state = {
  list: [],
  pagination: { current_page: 1, last_page: 1, per_page: 20 },
  total: 0,
  total_teachers: 0,
  errors: null,
};

const getters = {
  inspectionList: (s) => s.list,
  inspectionPagination: (s) => s.pagination,
  inspectionTotal: (s) => s.total,
  inspectionTotalTeachers: (s) => s.total_teachers,
};

const actions = {
  [INSPECTION_LIST](context, payload) {
    return new Promise((resolve) => {
      ApiService.query(INSPECTION_RESOURCE, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((response) => {
          reject(response);
        });
    });
  },
  [INSPECTION_PERSONAL](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(INSPECTION_PERSONAL, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_TEACHER_CATEGORY_LIST](context, payload) {
    return new Promise((resolve) => {
      ApiService.query(INSPECTION_TEACHER_CATEGORY_LIST, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((response) => {
          console.log(response);
        });
    });
  },
  [INSPECTION_TEACHER_CATEGORY_DOWNLOAD]() {
    return new Promise((resolve, reject) => {
      ApiService.query(INSPECTION_TEACHER_CATEGORY_DOWNLOAD).then(({data}) => {
          const filename = "Phân loại giảng viên.xlsx";
          const anchor = document.createElement("a");
          anchor.setAttribute("download", filename);
          anchor.setAttribute("href", data.data);
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);
          resolve(data);
      }).catch(({response}) => {
          reject(response);
      });
  }); 
  },
  [INSPECTION_TEACHER_CATEGORY_IMPORT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(INSPECTION_TEACHER_CATEGORY_IMPORT, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_TEACHER_PREVIEW_IMPORT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(INSPECTION_TEACHER_PREVIEW_IMPORT, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_EXPORT_ALL](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(INSPECTION_EXPORT_ALL, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_ASSIGN](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(INSPECTION_ASSIGN, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_DETAIL](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.query(INSPECTION_RESOURCE + '/' + id).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_SUPPLEMENT_CANDIDATE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${INSPECTION_SUPPLEMENT_CANDIDATE}/${payload.id}`, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_DELETE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(INSPECTION_RESOURCE, payload.id).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_UPDATE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put(INSPECTION_RESOURCE + '/' + payload.id, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_CREATE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(INSPECTION_RESOURCE, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_GET_HOMEWORK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(INSPECTION_GET_HOMEWORK, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_GET_PERSON_IN_CHARGE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(INSPECTION_GET_PERSON_IN_CHARGE, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_SAVE_EVALUATE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(INSPECTION_SAVE_EVALUATE, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [CREATE_ERROR_INSPECTION](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(CREATE_ERROR_INSPECTION, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_GET_MARK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${INSPECTION_GET_MARK}/${payload.id}`).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [INSPECTION_POST_MARK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(INSPECTION_POST_MARK, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
  [DELETE_SIMILAR_TASK](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post(DELETE_SIMILAR_TASK, payload).then(({data}) => {
        resolve(data);
      }).catch(({response}) => {
        reject(response);
      });
    });
  },
};

const mutations = {
  INSPECTION_SET_LIST(state, res) {
    state.list = res.data || [];
    state.pagination = res.pagination || { current_page: 1, last_page: 1, per_page: 20 };
    state.total = res.total || 0;
    state.total_teachers = res.total_teachers || 0;
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
